<template>
  <div id="home">
    <div class="container home-container full-width">
      <section class="hero">
        <div class="hero-left">
          <img src="../assets/HeroShapes.svg" alt="Random">
        </div>
        <div class="hero-right">
          <div class="hero-right--text">
            <h1 class="hero-right--text__heading">Hi! 👋🏼</h1>
            <div class="hero-right--text__paragraph">
              <p>My name's Usama and I love stories. I also love to design and code, and find myself constantly in search of inspiration to create something new and hopefully tell a story with.</p>
              <p>I’ve worked on both physical and digital Products. Education, Advertising, E-commerce, Content Management Systems and Digital & Print Media are some of the things I've had exposure to.</p>
              <p>I am always interested to try and learn new things. If you wanna collaborate, or just send something funny, <a href="mailto:postusama@gmail.com">hit me up</a> on the <a class="no-underline" href="mailto:postusama@gmail.com">📭</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {

  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  // @import url('../assets/Optima.ttf');
  .home-container{
    margin:0px;
    .hero {
      display:flex;
      height:100vh;
      justify-content: space-between;
      flex:1 1 auto;
      .hero-left {
        max-height:100%;
        overflow: hidden;
        text-align:left;
        position: relative;
        z-index: 0;
        width:50%;
        justify-content: flex-start;
        display: flex;
        // max-width:700px;
        img {
          height:100%;
        }
      }
      .hero-right {
        display:flex;
        flex:1 1 auto;
        margin:0 5rem 0 5rem;
        align-items:center;
        min-width: 50%;
        &--text {
          max-width:60rem;
          text-align:left;
          &__heading{
            font-size: 5rem;
            margin-bottom: 4rem
          }
          &__paragraph {
            margin-bottom:2rem;
            p,a {
              font-size: 3rem;
            }
            a.no-underline {
              text-decoration: none;
            }
          }
        }
      }
      @media (max-width: 1199px) {
        .hero-left {
          justify-content: flex-end;
        }
      }
      @media (max-width: 767px) {
        flex-flow: column;
        .hero-left {
          width: 100%;
          display: flex;
          align-items: flex-end;
          // justify-content: center;
          z-index: 0;
          img {
            transform: rotate(90deg);
            width: 100vw;
            height:initial;
          }
        }
        .hero-right {
          margin:0 15px;
          min-height: 58%;
          min-width: intial;
          z-index: 1;
          flex: initial;
           &--text {
              &__paragraph {
                p,a {
                  font-size: 2.5rem;
                }
              }
              &__heading {
                margin-top:0px;
              }
           }
        }
      }
    }
  }

</style>
